import React from 'react'
import './ContactCard.css'
import MyMap from '../../ContactMap/MyMap'
import { Divider } from 'antd'
import { TbClockHour5 } from 'react-icons/tb'

const ContactCard = () => {
return (
    <div className="card">
    <div className="business-card">
        <img
        className="bc-img"
        src="https://s3.amazonaws.com/tangledlead.com/images/Tangled+Lead.jpg"
        alt="Company Logo"
        />
        <div className="contact-address">
        <span className="text-color-blue fs-25">Dalton Algam</span>
        <span className="text-color-blue">Owner/Operator</span>
        <span className="text-color-blue">(469)-338-8263</span>
        <span className="text-color-blue email-font">dalton.tlw@yahoo.com</span>
        </div>
    </div>
    <Divider />
    <div className="hours-bg flex-col-stretch rem-pad-width">
        <div className="hours ">
        <TbClockHour5 />
        <h3 className="text-color-black text-align-center">
            Hours of Operation:
        </h3>
        </div>
        <div className="weekday-table">
        <div className="weekday">
            <span>Monday</span>
            <span>7:00 AM - 5:00 PM</span>
        </div>
        <div className="weekday">
            <span>Tuesday</span>
            <span>7:00 AM - 5:00 PM</span>
        </div>
        <div className="weekday">
            <span>Wednesday</span>
            <span>7:00 AM - 5:00 PM</span>
        </div>
        <div className="weekday">
            <span>Thursday</span>
            <span>7:00 AM - 5:00 PM</span>
        </div>
        <div className="weekday">
            <span>Friday</span>
            <span>7:00 AM - 5:00 PM</span>
        </div>
        <div className="weekday">
            <span>Saturday</span>
            <span>7:00 AM - NOON</span>
        </div>
        <div className="weekday">
            <span>Sunday</span>
            <span>CLOSED</span>
        </div>
        </div>
    </div>
    <div className="W-100-P">
        <h3 className="text-align-center text-color-black">
        Proudly serving DFW and surrounding areas
        </h3>
        <MyMap />
    </div>
    </div>
)
}

export default ContactCard


